import { metaAccount } from '@/router/meta-config'
// TODO
const permissionKey = 'PLACE'

export default [
  // places
  {
    path: '/ordersBooking',
    name: 'page-orders-booking',
    component: () => import('@/pages/ordersBooking'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  }
]
